import { useIntercom } from 'react-use-intercom';
import app from 'srcJs/App';

var useIntercomShow = function useIntercomShow() {
  if (!app.getExternalApp().isEnableIntercom()) {
    return function () {
      return undefined;
    };
  }

  var _useIntercom = useIntercom(),
      show = _useIntercom.show;

  return show;
};

export { useIntercomShow };